/**
 * Quantidade de tamanhos do menu lateral. Deve ser igual ao valor definido no SASS.
 * ATENÇÃO: Diminuir este valor pode alterar layouts já existentes.
 */
const MAX_SIDE_MENU_SIZES = 5;

/**
 * Utilitários para gerenciamento do tamanho do menu lateral.
 */
export default {
  /**
   * Retorna as classes CSS usadas para estilização do menu lateral e gerenciamento de tamanho,
   * As classes retornadas são as mesmas geradas pelos mixins do SASS.
   * @param {String} prefix Prefixo das classes.
   * @param {Boolean} collapsed Menu colapsado.
   * @param {Number} size Tamanho do menu.
   * @returns {Object} Objeto de classes CSS no formato "classe: bool".
   */
  getSizeClasses(prefix, collapsed, size) {
    if (size < 1 || size > MAX_SIDE_MENU_SIZES) {
      throw new Error(`Tamanho inválido ${size}. Valores válidos entre 1 e ${MAX_SIDE_MENU_SIZES}`);
    }

    return {
      [`${prefix}-collapsed`]: collapsed,
      [`${prefix}-size-${size}`]: !collapsed,
    };
  },
};
